if (!customElements.get('cart-upsell-variant-picker')) {
  customElements.define('cart-upsell-variant-picker', class CartUpsellVariantPicker extends HTMLElement {
    constructor() {
      super();
      const json = this.querySelector('script[type="application/json"]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.selects = Array.from(this.querySelectorAll('select'));
      this.input = this.querySelector('input[name="id"]');
      this.button = this.querySelector('button[type="submit"]');

      this.selects.forEach((select) => {
        select.addEventListener('change', this.updateVariant.bind(this));
      });

      this.updateVariant();
    }

    updateVariant() {
      const selectedValues = this.selects.map((select) => select.value);
      const matchedVariant = this.variants.find((variant) => {
        return selectedValues.every((value, index) => variant[`option${index + 1}`] === value);
      });

      if (!this.input || !this.button) return;

      if (matchedVariant) {
        this.input.value = matchedVariant.id;
        this.button.disabled = !matchedVariant.available;
        this.button.classList.toggle('cart-drawer__upsell-add--disabled', !matchedVariant.available);
      } else {
        this.button.disabled = true;
        this.button.classList.add('cart-drawer__upsell-add--disabled');
      }
    }
  });
}
